import ShowRating from 'common/components/show-rating';
import styles from './styles.less';
import Trailer from 'show-page/components/trailer';
import { camelCase } from 'lodash';
import { observer } from 'mobx-react';


function ShowHero(props) {
    const alignmentClassName = camelCase(`align ${props.imageAlignment}`);
    const className = cx(styles.root, props.className, {
        [styles.hasTrailer]: props.trailer,
        [styles.visible]: props.visible
    });
    return (
        <div className={ className }>
            <div className={ cx(styles.imageContainer, styles[alignmentClassName]) }>
                <ShowRating
                    className={ styles.showRating }
                    rating={ props.showRating }
                />
                <img
                    className={ styles.image }
                    src={ props.image }
                    alt={ props.showTitle }
                />
            </div>
            { !!props.trailer &&
            <Trailer
                className={ styles.trailer }
                video={ props.trailer }
                visible={ props.visible }
            /> }
        </div>
    );
}

ShowHero.propTypes = {
    image: React.PropTypes.string.isRequired,
    showTitle: React.PropTypes.string,
    visible: React.PropTypes.bool.isRequired
};

ShowHero.defaultProps = {
    visible: true
};


export default observer(ShowHero);



// WEBPACK FOOTER //
// ./src/show-page/components/show-hero/index.js